var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPaging)?_c('div',{staticClass:"pagination-tool",attrs:{"align":"left"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8"},[(_vm.showPaging)?_c('Page',{attrs:{"show-elevator":"","show-sizer":"","current":_vm.page,"total":_vm.total,"page-size":_vm.limit,"page-size-opts":_vm.tablePaginationSize,"size":"small","placement":"top"},on:{"on-change":_vm.handlerCurrentPage,"on-page-size-change":_vm.handlerPageSize}}):_vm._e()],1)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8444fb54","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/PageHelper.vue
// module id = 590
// module chunks = 36